export const FIRMS = ["smarta", "preis-und-partner"] as const;

export type Firm = (typeof FIRMS)[number];

export const FIRM_LABELS: Record<Firm, string> = {
  smarta: "smarta",
  "preis-und-partner": "Preis & Partner",
};

export const isFirm = (value: unknown): value is Firm =>
  typeof value === "string" && FIRMS.includes(value as Firm);
